import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, ExternalLink } from 'lucide-react';
const books = [{
  title: 'The Silent Path',
  subtitle: 'A Journey to Inner Peace',
  description: 'Discover the transformative power of silence and learn ancient meditation techniques for modern life.',
  price: '$24.99',
  image: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?q=80&w=1887&auto=format&fit=crop',
  bestseller: true
}, {
  title: 'Awakening the Soul',
  subtitle: 'Wisdom from the East',
  description: 'A comprehensive guide to spiritual awakening through daily practices and mindful living.',
  price: '$29.99',
  image: 'https://images.unsplash.com/photo-1589998059171-988d887df646?q=80&w=1976&auto=format&fit=crop',
  bestseller: false
}, {
  title: 'Beyond the Mind',
  subtitle: 'Transcending Thought',
  description: 'Explore the depths of consciousness and learn to transcend the limitations of the thinking mind.',
  price: '$27.99',
  image: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?q=80&w=1998&auto=format&fit=crop',
  bestseller: false
}, {
  title: 'The Lotus Sutra',
  subtitle: 'Teachings for Daily Life',
  description: 'Practical wisdom and guided meditations for cultivating peace, compassion, and clarity.',
  price: '$22.99',
  image: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?q=80&w=1887&auto=format&fit=crop',
  bestseller: false
}];
export function Books() {
  return <section className="py-24 bg-[#F5FAFD]" data-id="element-45">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-46">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-47">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-48">
            <span className="text-[#5B9BD5] font-medium tracking-widest uppercase text-sm mb-2 block" data-id="element-49">
              Wisdom in Words
            </span>
            <h2 className="font-serif text-4xl md:text-5xl text-[#3A5F7D] mb-6" data-id="element-50">
              Books by Tatwagyani Sumanand Sagar
            </h2>
            <p className="text-lg text-[#6B8FA8] max-w-2xl mx-auto" data-id="element-51">
              Timeless teachings and practical guidance for your spiritual
              journey, now available in print and digital formats
            </p>
          </motion.div>
        </div>

        {/* Books Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-52">
          {books.map((book, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 flex flex-col" data-id="element-53">
              {/* Book Cover */}
              <div className="relative aspect-[3/4] overflow-hidden bg-gray-100" data-id="element-54">
                <img src={book.image} alt={book.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-55" />
                {book.bestseller && <div className="absolute top-4 right-4 bg-[#D4AF37] text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider shadow-lg" data-id="element-56">
                    Bestseller
                  </div>}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-57" />
              </div>

              {/* Book Info */}
              <div className="p-6 flex flex-col flex-grow" data-id="element-58">
                <h3 className="font-serif text-xl font-bold text-[#3A5F7D] mb-1 group-hover:text-[#5B9BD5] transition-colors" data-id="element-59">
                  {book.title}
                </h3>
                <p className="text-sm text-[#D4AF37] font-medium mb-3 italic" data-id="element-60">
                  {book.subtitle}
                </p>
                <p className="text-sm text-[#6B8FA8] mb-4 leading-relaxed flex-grow" data-id="element-61">
                  {book.description}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-gray-100" data-id="element-62">
                  <span className="font-serif text-2xl font-bold text-[#3A5F7D]" data-id="element-63">
                    {book.price}
                  </span>
                  <button className="flex items-center gap-2 bg-[#5B9BD5] hover:bg-[#4A7FB8] text-white px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 transform hover:scale-105 shadow-md" data-id="element-64">
                    <ShoppingCart className="w-4 h-4" data-id="element-65" />
                    Buy Now
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* View All Books Link */}
        <div className="text-center mt-12" data-id="element-66">
          <motion.a href="#" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="inline-flex items-center gap-2 text-[#5B9BD5] hover:text-[#4A7FB8] font-semibold group" data-id="element-67">
            View Complete Collection
            <ExternalLink className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" data-id="element-68" />
          </motion.a>
        </div>
      </div>
    </section>;
}